"use client";

import createIcon from './util/createIcon';
export default createIcon('M22,21H2V3H4V15.54L9.5,6L16,9.78L20.24,2.45L21.97,3.45L22,21Z', 'ChartAreasplineVariant');